export const filterData = [
  {
    id: "1",
    title: "All",
  },
  {
    id: "2",
    title: "Development",
  },
  {
    id: "3",
    title: "Business",
  },
  {
    id: "4",
    title: "Design",
  },
  {
    id: "5",
    title: "Lifestyle",
  },
];

const reviews = [
  {
    id: 1,
    name: "Kamal Sagar",
    heading: "Open for Software Engineer role",
    image: "https://media.licdn.com/dms/image/D4D03AQE0JMuo39z17A/profile-displayphoto-shrink_800_800/0/1681541680010?e=2147483647&v=beta&t=XUDWBMkJ4KASHULEvBhLkcUXJjIHcj1UZL8SkeTjGy0",
    text: "I am a passionate and dedicated software developer with a strong enthusiasm for programming and a relentless drive to learn and develop new technical and management skills. I am committed to making the best use of my expertise and knowledge to contribute to the growth and success of an organization.",
  },
  {
    id: 2,
    heading: "technical content analyst",
    text: "I have worked as a Technical Content Analyst in GeeksforGeeks where i worked with diffenet content teams and help them to improve the ranking of article and I also review the Python article.",
  },
  {
    id: 3,
    heading: "Education",
    text: "I have done my bachelor of technology in computer science from bharat institute of technology, meerut where I have learned computer fundamentals like OS, CN, DBMS, OPPS and programming languages which include C, C++, Java, Python and JavaScript.",
  },
  {
    id: 4,
    heading: "Projects",
    text: "I have made many project till now few of them are modern bank web app, ChatGPT clone, ToDo Web app and this edtech web app. I have used different technologies which include HTML, CSS, JavaScript, React, TailwindCSS, Python, Flask, and MongoDB. ",
  },

];

export default reviews;


export const apiUrl = "https://codehelp-apis.vercel.app/api/get-top-courses";
